import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";
import { IdentityProviderChangeRequestResponse } from "@idw-types/data/identity-providers";

type UnsubmitIdentityProviderChangeRequestModalProps = {
    identityProviderName: string;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<IdentityProviderChangeRequestResponse>;
};

export const UnsubmitIdentityProviderChangeRequestModal = (props: UnsubmitIdentityProviderChangeRequestModalProps) => {
    const { identityProviderName, onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>This action will <b>UNSUBMIT</b> the Change Request for the Identity Provider named <b>{identityProviderName}</b>.</p>
                <p>
                    The review of this Change Request will be canceled so that you may make further changes and then re-submit the change request at some point in the future.
                </p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.UNSUBMIT}
            title={"Unsubmit Identity Provider Change Request"}
            body={bodyElement}
            buttonText={"Unsubmit Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};